import { VueCookieNext as VueCookie } from 'vue-cookie-next'
import SHA256 from 'crypto-js/sha256'

export default {
  hasToken: function () {
		return VueCookie.isCookieAvailable('token')
	},
	getToken: function () {
		return VueCookie.getCookie('token')
	},
	setToken: function (token) {
		VueCookie.setCookie('token', token, { expire: '1d' })
	},
	deleteToken: function () {
		VueCookie.removeCookie('token')
	},
	refreshToken: function () {
		const token = VueCookie.getCookie('token')
		VueCookie.setCookie('token', token, { expire: '1d' })
	},
	getCookie: function (name) {
		return VueCookie.getCookie(name)
	},
	setCookie: function (name, value, expiry) {
		VueCookie.setCookie(name, value, { expire: expiry })
	},
	deleteCookie: function (name) {
		VueCookie.removeCookie(name)
	},
	setCsToken: function (token) {
		VueCookie.setCookie('token', token, { expire: '5min' })
	},
  hasCookie: function (name) {
		return VueCookie.isCookieAvailable(name)
	},
	// Meta external ID
  hasExternalId: function () {
		return VueCookie.isCookieAvailable('_extid')
	},
	getExternalId: function () {
		return VueCookie.getCookie('_extid')
	},
	setExternalId: function (user_id) {
		const hash = SHA256(user_id).toString()
    VueCookie.setCookie('_extid', hash, { expire: '30d' })
	},
}
